import { UserRoleDto } from '../_models/userRole.models';
import { IEDistributionDto } from '../_models';
import axios, { AxiosResponse } from 'axios';
import { UserDetailDto } from '../_models';
import {
    AddUpdateIEDistributionPayloadStructure,
    DeleteIEDistributionPayloadStructure,
    IEDistributionListFilterStructure,
} from "../_models/app.models";

const getIEDistributionList = (filters: IEDistributionListFilterStructure): Promise<AxiosResponse<IEDistributionDto[]>> => {
    return axios.get('/api/v1/IEDistributions', {
        params: filters
    });
}

const updatePerWeekHour = (payload: IEDistributionListFilterStructure): Promise<AxiosResponse<IEDistributionDto[]>> => {
    return axios.put('/api/v1/IEDistributions/updatePerWeekHour', payload);
}

const addOrUpdateIEDistribution = (payload: AddUpdateIEDistributionPayloadStructure) => {
    return axios.put('/api/v1/IEDistributions/addOrUpdateIEDistribution', payload);
}

const getIEDistribution = (id: number) => {
    return axios.get(`/api/v1/IEDistributions/${id}`);
}

const deleteIEDistribution = (payload: DeleteIEDistributionPayloadStructure) => {
    return axios.delete(`/api/v1/IEDistributions/${payload.id}/${payload.isDeleteAll}`);
}

export const ieDistributionService = {
    getIEDistributionList,
    getIEDistribution,
    deleteIEDistribution,
    updatePerWeekHour,
    addOrUpdateIEDistribution
}
